import { Button, Divider, Input, Modal, Select, Spin, Table, Dropdown, Menu, Tooltip } from 'antd';
import UserProfile from '../../component/UserProfile';
import React, { useEffect, useRef, useState } from 'react';
import { reqGetListKey, reqLicensePack } from '../../services';
import { ListKey, SummaryItem, LicensePack } from '../../constant/types';
import moment from 'moment';
import './index.css';
import { ActiveKey, InactiveKey, RevokeKey, TotalKey } from '../../assets';
import SummaryView from './component/SummaryItem';
import ExcelJS from 'exceljs';
const statusFilter = [
    {
        text: 'Chưa kích hoạt',
        value: 1
    },
    {
        text: 'Đã kích hoạt',
        value: 3
    },
    {
        text: 'Tất cả',
        value: 5
    }
]

const Home: React.FC = () => {
    const [listKey, setListKey] = useState<ListKey>();
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [statusKey, setStatusKey] = useState<any>(1);
    const [keyType, setKeyType] = useState<any>('all');
    const [pageSize, setPageSize] = useState<number>(20);
    const [loading, setLoading] = useState<boolean>(false);
    const [licensePacks, setLicensePacks] = useState<LicensePack[]>([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [modalContent, setModalContent] = useState<{ title: string; content: string }>({ title: '', content: '' });
    const [summaryInfor, setSummaryInfor] = useState<SummaryItem[]>([
        {
            "status": 0,
            "count": 0
        },
        {
            "status": 1,
            "count": 0
        },
        {
            "status": 2,
            "count": 0
        }
    ]);

    // Helper function to get license pack name by ID
    const getLicensePackName = (licensePackId: string): string => {
        const licensePack = licensePacks.find(pack => pack.id === licensePackId);
        return licensePack ? licensePack.name : '1 Năm'; // Fallback to default
    };

    // Helper function để tính số ngày còn lại từ license_expired_date
    const getDaysRemaining = (licenseExpiredDate?: string): number => {
        if (!licenseExpiredDate) return 0;
        // license_expired_date là timestamp string (seconds)
        const expiryTimestamp = parseInt(licenseExpiredDate) * 1000; // Convert to milliseconds
        const now = new Date().getTime();
        const diffTime = expiryTimestamp - now;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return Math.max(0, diffDays);
    };

    // Function để show popup với thông tin đầy đủ
    const showInfoModal = (title: string, content: string) => {
        setModalContent({ title, content });
        setModalVisible(true);
    };

    // Generate dynamic filter options from license packs
    const getKeyTypeFilterOptions = () => {
        const dynamicOptions = licensePacks.map(pack => ({
            text: pack.name,
            value: pack.id
        }));
        
        return [
            ...dynamicOptions,
            {
                text: 'Tất cả loại mã',
                value: 'all'
            }
        ];
    };

    const fetchListKey = async (page?: number, status?: number, pageSizeK?: number, keyTypeFilter?: string) => {
        setLoading(true);
        try {
        const statusK = (status == 5) ? undefined : status || statusKey;
        const keyTypeK = keyTypeFilter || keyType;
        setStatusKey(statusK);
        setKeyType(keyTypeK);
        const finalData: {
            size: number,
            page: number,
            status?: number,
            page_size?: number,
            license_pack_id?: string,
        } = {
            size: pageSizeK || pageSize,
            page: page || pageNumber,
            status: statusK,
        };

        // Add license pack filter if not 'all'
        if (keyTypeK && keyTypeK !== 'all') {
            finalData.license_pack_id = keyTypeK;
        }

        for (const key in finalData) {
            const value = finalData[key as keyof typeof finalData];
                if (value == null || String(value) === '' || Number(value) === 0) {
                delete finalData[key as keyof typeof finalData];
            }
        }
        const data: ListKey = await reqGetListKey(finalData);
        setListKey(data);
        } finally {
            setLoading(false);
        }
    };

    // Helper function để tạo Excel với ExcelJS
    const createExcelWithData = async (data: any[], fileName: string) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Danh sách Mã kích hoạt');

        // Định nghĩa columns với width lớn hơn
        worksheet.columns = [
            { header: 'STT', key: 'stt', width: 15 },
            { header: 'Mã kích hoạt', key: 'key', width: 35 },
            { header: 'Loại mã', key: 'licenseType', width: 25 },
            { header: 'Trạng thái', key: 'status', width: 20 },
            { header: 'Thời điểm kích hoạt', key: 'activation', width: 30 },
            { header: 'Thông tin người kích hoạt', key: 'userInfo', width: 40 }
        ];

        // Style cho header - chỉ tô màu các cột được sử dụng
        worksheet.getRow(1).font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
        worksheet.getRow(1).alignment = { 
            horizontal: 'center', 
            vertical: 'middle',
            wrapText: true 
        };
        worksheet.getRow(1).height = 30; // Tăng chiều cao header
        
        // Chỉ tô màu các cột được sử dụng (A, B, C, D, E, F)
        const headerCells = ['A1', 'B1', 'C1', 'D1', 'E1', 'F1'];
        headerCells.forEach(cellAddress => {
            const cell = worksheet.getCell(cellAddress);
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FF4472C4' }
            };
        });

        // Thêm dữ liệu
        data.forEach((item, index) => {
            const row = worksheet.addRow({
                stt: index + 1,
                key: item.key,
                licenseType: item.licenseType,
                status: item.status,
                activation: item.activation,
                userInfo: item.userInfo
            });

            // Style cho data rows
            row.font = { size: 11 };
            row.alignment = { 
                vertical: 'middle', 
                horizontal: 'left',
                wrapText: true 
            };
            row.height = 30; // Tăng chiều cao dòng dữ liệu
            
            // Căn giữa cột STT
            const sttCell = row.getCell(1); // Cột A (STT)
            sttCell.alignment = {
                vertical: 'middle',
                horizontal: 'center'
            };
        });

        // Áp dụng border cho tất cả cells
        worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
            row.eachCell({ includeEmpty: false }, (cell, colNumber) => {
                cell.border = {
                    top: { style: 'thin', color: { argb: 'FF000000' } },
                    left: { style: 'thin', color: { argb: 'FF000000' } },
                    bottom: { style: 'thin', color: { argb: 'FF000000' } },
                    right: { style: 'thin', color: { argb: 'FF000000' } }
                };
            });
        });

        // Header có border dày hơn
        worksheet.getRow(1).eachCell({ includeEmpty: false }, (cell) => {
            cell.border = {
                top: { style: 'medium', color: { argb: 'FF000000' } },
                left: { style: 'medium', color: { argb: 'FF000000' } },
                bottom: { style: 'medium', color: { argb: 'FF000000' } },
                right: { style: 'medium', color: { argb: 'FF000000' } }
            };
        });

        // Xuất file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(url);
    };

    const exportToExcel = async (exportType: 'filtered' | 'all' = 'filtered') => {
        if (exportType === 'filtered') {
            // Xuất theo bộ lọc hiện tại - lấy tất cả kết quả với size 999999
            setLoading(true);
            try {
                // Gọi API với bộ lọc hiện tại nhưng size = 999999 để lấy tất cả kết quả
                const filteredData: ListKey = await reqGetListKey({
                    size: 999999,
                    page: 1,
                    status: statusKey !== 'all' ? statusKey : undefined,
                    license_pack_id: keyType !== 'all' ? keyType : undefined
                });
                
                if (!filteredData?.page || filteredData.page.length === 0) {
                    return;
                }

                const excelData = filteredData.page.map((item, index) => {
                    // Get user info based on provider
                    let userInfoText = '--';
                    if (item.status !== 1 && item.user_info) {
                        const userInfo = item.user_info;
                        switch (userInfo.sign_in_provider) {
                            case "gofa":
                                userInfoText = `SĐT: ${userInfo.phone_number || '--'}`;
                                break;
                            case "google":
                                userInfoText = `Email: ${userInfo.email || '--'}`;
                                break;
                            case "apple":
                                userInfoText = `Apple ID: ${userInfo.external_user_id || '--'}`;
                                break;
                            default:
                                userInfoText = '--';
                        }
                    }

                    // Thời điểm kích hoạt cho mã đã kích hoạt từ active_time
                    let activationText = '--';
                    if (item.status === 3 && item.active_time) {
                        const activationDate = new Date(item.active_time * 1000);
                        activationText = `${activationDate.toLocaleDateString('vi-VN')} ${activationDate.toLocaleTimeString('vi-VN', { hour: '2-digit', minute: '2-digit' })}`;
                    }

                    return {
                        key: item.key,
                        licenseType: getLicensePackName(item.license_pack_id),
                        status: item.status == 1 ? 'Chưa kích hoạt' : item.status == 3 ? 'Đã kích hoạt' : 'Đã thu hồi',
                        activation: activationText,
                        userInfo: userInfoText
                    };
                });

                // Generate filename
                const currentDate = moment().format('DDMMYYYY');
                let statusText = 'tatca';
                if (statusKey === 1) statusText = 'chuakichhoat';
                else if (statusKey === 3) statusText = 'dakichhoat';
                
                let licensePackText = '';
                if (keyType && keyType !== 'all') {
                    const selectedLicensePack = licensePacks.find(pack => pack.id === keyType);
                    if (selectedLicensePack) {
                        licensePackText = selectedLicensePack.name
                            .toLowerCase()
                            .replace(/\s+/g, '')
                            .replace(/năm/g, 'nam')
                            .replace(/tháng/g, 'thang');
                    } else {
                        licensePackText = 'tatca';
                    }
                } else {
                    licensePackText = 'tatca';
                }
                
                const fileName = `${currentDate}_ma${licensePackText}_${statusText}.xlsx`;
                await createExcelWithData(excelData, fileName);
            } finally {
                setLoading(false);
            }
        } else {
            // Xuất tất cả dữ liệu
            exportAllData();
        }
    };

    const exportAllData = async () => {
        setLoading(true);
        try {
            // Gọi API để lấy tất cả dữ liệu (không có bất kỳ filter nào)
            const allData: ListKey = await reqGetListKey({
                size: 999999, // Lấy tất cả dữ liệu
                page: 1
                // Không truyền status, license_pack_id, hoặc bất kỳ filter nào khác
            });
            
            if (!allData?.page || allData.page.length === 0) {
                return;
            }

            const excelData = allData.page.map((item, index) => {
                // Get user info based on provider
                let userInfoText = '--';
                if (item.status !== 1 && item.user_info) {
                    const userInfo = item.user_info;
                    switch (userInfo.sign_in_provider) {
                        case "gofa":
                            userInfoText = `SĐT: ${userInfo.phone_number || '--'}`;
                            break;
                        case "google":
                            userInfoText = `Email: ${userInfo.email || '--'}`;
                            break;
                        case "apple":
                            userInfoText = `Apple ID: ${userInfo.external_user_id || '--'}`;
                            break;
                        default:
                            userInfoText = '--';
                    }
                }

                // Thời điểm kích hoạt cho mã đã kích hoạt từ active_time
                let activationText = '--';
                if (item.status === 3 && item.active_time) {
                    const activationDate = new Date(item.active_time * 1000);
                    activationText = `${activationDate.toLocaleDateString('vi-VN')} ${activationDate.toLocaleTimeString('vi-VN', { hour: '2-digit', minute: '2-digit' })}`;
                }

                return {
                    key: item.key,
                    licenseType: getLicensePackName(item.license_pack_id),
                    status: item.status == 1 ? 'Chưa kích hoạt' : item.status == 3 ? 'Đã kích hoạt' : 'Đã thu hồi',
                    activation: activationText,
                    userInfo: userInfoText
                };
            });

            const currentDate = moment().format('DDMMYYYY');
            const fileName = `${currentDate}_matatca_tatca.xlsx`;
            await createExcelWithData(excelData, fileName);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const fetchKeyList = async () => {
            setLoading(true);
            try {
                // Get license packs for mapping
                const licensePacksData = await reqLicensePack();
                setLicensePacks(licensePacksData);

                // Get all data for display (with current default filter)
            const data: ListKey = await reqGetListKey({
                    size: 20, page: 1, status: 1 // Default filter for display
            });
            
            
            setListKey(data);
            const updatedSummary = [...summaryInfor]; // Create a copy of the existing summaryInfor array

                // Reset all counts to 0 first
                updatedSummary.forEach((summaryItem) => {
                    summaryItem.count = 0;
                });

                // Get individual status counts by making separate API calls
                const [status1Data, status3Data] = await Promise.all([
                    reqGetListKey({ size: 1, page: 1, status: 1 }), // Chưa kích hoạt
                    reqGetListKey({ size: 1, page: 1, status: 3 })  // Đã kích hoạt
                ]);

                // Calculate total by adding status counts (most accurate method)
                const status1Count = status1Data.totalResult || 0;
                const status3Count = status3Data.totalResult || 0;
                const totalKeys = status1Count + status3Count;

                // Debug logging
                console.log('🔍 Debug Summary Counts:');
                console.log('Status 1 Data (chưa kích hoạt):', status1Count);
                console.log('Status 3 Data (đã kích hoạt):', status3Count);
                console.log('Calculated Total Keys (status1 + status3):', totalKeys);

                // Update summary with accurate counts from each status API call
                const statusOneIndex = updatedSummary.findIndex((existingItem) => existingItem.status === 1);
                const statusThreeIndex = updatedSummary.findIndex((existingItem) => existingItem.status === 3);
                
                if (statusOneIndex !== -1) {
                    updatedSummary[statusOneIndex].count = status1Count;
                } else {
                    updatedSummary.push({ status: 1, count: status1Count });
                }
                
                if (statusThreeIndex !== -1) {
                    updatedSummary[statusThreeIndex].count = status3Count;
                } else {
                    updatedSummary.push({ status: 3, count: status3Count });
                }

                // Set the count for status code 0 to the total keys from API
            const statusZeroIndex = updatedSummary.findIndex((existingItem) => existingItem.status === 0);
            if (statusZeroIndex !== -1) {
                    updatedSummary[statusZeroIndex].count = totalKeys;
            } else {
                    updatedSummary.push({ status: 0, count: totalKeys });
                }

                console.log('📊 Final Summary Data:', updatedSummary);
                setSummaryInfor(updatedSummary);
            } finally {
                setLoading(false);
            }
        };
        fetchKeyList();
    }, []);


    return (
        <div className="h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50 overflow-hidden">
            <div className='h-full flex flex-col px-4 sm:px-6 pt-1 pb-2'>
                {/* User Profile Header */}
                <div className="flex justify-end mb-1">
                    <UserProfile />
                </div>


                {/* Table Section */}
                <div className='flex-1 bg-white rounded-lg shadow-lg border border-gray-100 overflow-hidden flex flex-col min-h-0'>
                    <div className='p-2 sm:p-3 border-b border-gray-100'>
                        <div className='flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2'>
                            <div className='flex flex-col sm:flex-row sm:items-start sm:gap-6 gap-2'>
                                <h2 className='text-base sm:text-lg font-bold text-gray-900'>Danh sách Mã kích hoạt</h2>
                                {/* Summary Stats in Header */}
                                <div className='flex flex-wrap items-center gap-4 text-sm'>
                    {summaryInfor.map((item, index) => {
                                        let label = '';
                                        let bgColor = '';
                                        let textColor = '';
                                        
                                        if (item.status === 0) {
                                            label = 'Tổng số mã';
                                            bgColor = 'bg-blue-50';
                                            textColor = 'text-blue-700';
                                        } else if (item.status === 1) {
                                            label = 'Mã chưa kích hoạt';
                                            bgColor = 'bg-orange-50';
                                            textColor = 'text-orange-700';
                                        } else if (item.status === 3) {
                                            label = 'Mã đã kích hoạt';
                                            bgColor = 'bg-green-50';
                                            textColor = 'text-green-700';
                            } else {
                                            return null;
                                        }
                                        
                                        return (
                                            <div key={index} className={`${bgColor} ${textColor} px-3 py-1.5 rounded-lg border border-opacity-20`}>
                                                <span className='font-medium'>{label}:</span>
                                                <span className='ml-1 font-semibold'>
                                                    {typeof item.count === 'number' 
                                                        ? item.count.toLocaleString('vi-VN') 
                                                        : Number(item.count).toLocaleString('vi-VN')
                                                    }
                                                </span>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                            <div className='flex flex-col sm:flex-row gap-2'>
                                <Dropdown
                                    menu={{
                                        items: [
                                            {
                                                key: 'filtered',
                                                label: 'Xuất theo bộ lọc',
                                                onClick: () => exportToExcel('filtered'),
                                            },
                                            {
                                                key: 'all',
                                                label: 'Xuất tất cả',
                                                onClick: () => exportToExcel('all'),
                                            },
                                        ],
                                    }}
                                    placement="bottomRight"
                                >
                                    <Button
                                        type='primary'
                                        disabled={!listKey?.page || listKey.page.length === 0}
                                        className='bg-blue-600 border-blue-600 w-full sm:w-auto'
                                    >
                                        Xuất Excel ▼
                                    </Button>
                                </Dropdown>
                            </div>
                        </div>
                    </div>

                    {/* Custom Pagination with Filters */}
                    <div className='flex-shrink-0 border-b border-gray-100 bg-white px-3 sm:px-4 py-3 shadow-sm'>
                        <div className='flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4'>
                            {/* Filters Section - Left */}
                            <div className='flex flex-col sm:flex-row gap-3'>
                                <div className='flex items-center gap-2'>
                                    <span className='text-sm font-medium text-gray-700'>Trạng thái:</span>
                                    <div className='flex gap-1'>
                                        {statusFilter.map((item) => (
                                            <Button
                                                key={item.value}
                                                type={statusKey === item.value ? 'primary' : 'default'}
                                                size='small'
                                                onClick={() => {
                                                    setStatusKey(item.value);
                                                    setPageNumber(1);
                                                    fetchListKey(1, item.value, pageSize);
                                                }}
                                                className={`px-3 py-1 text-xs w-24 text-center ${
                                                    statusKey === item.value 
                                                        ? 'bg-blue-600 border-blue-600 text-white' 
                                                        : 'bg-white border-gray-300 text-gray-700 hover:border-blue-400'
                                                }`}
                                            >
                                                {item.text}
                                            </Button>
                                        ))}
                                    </div>
                                </div>
                                <div className='flex items-center gap-2'>
                                    <span className='text-sm font-medium text-gray-700'>Loại mã:</span>
                                    <Select
                                        onChange={(value) => {
                                            setKeyType(value);
                                            setPageNumber(1);
                                            fetchListKey(1, statusKey, pageSize, value)
                                        }}
                                        placeholder='Chọn loại mã'
                                        value={keyType}
                                        className='w-full sm:w-[150px]'
                                        options={getKeyTypeFilterOptions().map((item) => ({
                                            label: item.text,
                                            value: item.value
                                        }))}
                                    />
                                </div>
                            </div>
                            
                            {/* Pagination Section - Right */}
                            <div className='flex flex-col sm:flex-row items-start sm:items-center gap-3'>
                                <div className='flex items-center gap-2'>
                                    <span className='text-sm text-gray-700'>Số mục/trang:</span>
                                    <Select
                                        value={pageSize}
                                        onChange={(value) => {
                                            setPageSize(value);
                                            setPageNumber(1);
                                            fetchListKey(1, statusKey, value);
                                        }}
                                        className='w-24'
                                        size='small'
                                        options={[
                                            { label: '10', value: 10 },
                                            { label: '20', value: 20 },
                                            { label: '50', value: 50 },
                                            { label: '100', value: 100 },
                                            { label: '200', value: 200 },
                                            { label: '500', value: 500 },
                                            { label: '1000', value: 1000 },
                                            { label: '2000', value: 2000 },
                                            { label: '5000', value: 5000 }
                                        ]}
                                    />
                                </div>
                                <div className='flex items-center gap-1'>
                                    <Button
                                        disabled={pageNumber <= 1}
                                        onClick={() => {
                                            const newPage = pageNumber - 1;
                                            setPageNumber(newPage);
                                            fetchListKey(newPage, statusKey, pageSize);
                                        }}
                                        size='small'
                                        type='default'
                                        className='px-2'
                                    >
                                        ‹
                                    </Button>

                                    {/* Smart Page Numbers */}
                                    <div className='hidden sm:flex items-center gap-1'>
                                        {(() => {
                                            const totalPages = Math.ceil((listKey?.totalResult || 0) / pageSize);
                                            const pages = [];
                                            const showPages = 5; // Maximum pages to show

                                            if (totalPages <= showPages) {
                                                // Show all pages if total is small
                                                for (let i = 1; i <= totalPages; i++) {
                                                    pages.push(i);
                                                }
                                            } else {
                                                // Smart pagination logic
                                                const startPage = Math.max(1, pageNumber - 1);
                                                const endPage = Math.min(totalPages, pageNumber + 1);

                                                // Always show first page
                                                if (startPage > 1) {
                                                    pages.push(1);
                                                    if (startPage > 2) {
                                                        pages.push('...');
                                                    }
                                                }

                                                // Show current page range
                                                for (let i = startPage; i <= endPage; i++) {
                                                    pages.push(i);
                                                }

                                                // Always show last page
                                                if (endPage < totalPages) {
                                                    if (endPage < totalPages - 1) {
                                                        pages.push('...');
                                                    }
                                                    pages.push(totalPages);
                                                }
                                            }

                                            return pages.map((page, index) => {
                                                if (page === '...') {
                                                    return (
                                                        <span key={`ellipsis-${index}`} className='px-1 py-1 text-gray-400 text-sm'>
                                                            ...
                                                        </span>
                                                    );
                                                }

                                                const isActive = page === pageNumber;
                                                return (
                                                    <Button
                                                        key={page}
                                                        type={isActive ? 'primary' : 'text'}
                                                        size='small'
                                                        className={`w-7 h-7 p-0 text-xs ${isActive ? 'bg-blue-600' : ''}`}
                                                        onClick={() => {
                                                            setPageNumber(page as number);
                                                            fetchListKey(page as number, statusKey, pageSize);
                                                        }}
                                                    >
                                                        {page}
                                                    </Button>
                                                );
                                            });
                                        })()}
                                    </div>

                                    {/* Mobile: Show current page input */}
                                    <div className='flex sm:hidden items-center gap-1'>
                                        <Input
                                            value={pageNumber}
                                            onChange={(e) => {
                                                const value = parseInt(e.target.value);
                                                if (value > 0 && value <= Math.ceil((listKey?.totalResult || 0) / pageSize)) {
                                                    setPageNumber(value);
                                                }
                                            }}
                                            onPressEnter={(e) => {
                                                const value = parseInt((e.target as HTMLInputElement).value);
                                                if (value > 0 && value <= Math.ceil((listKey?.totalResult || 0) / pageSize)) {
                                                    fetchListKey(value, statusKey, pageSize);
                                                }
                                            }}
                                            className='w-10 text-center'
                                            size='small'
                                        />
                                        <span className='text-xs text-gray-500'>/ {Math.ceil((listKey?.totalResult || 0) / pageSize)}</span>
                                    </div>

                                    <Button
                                        disabled={pageNumber >= Math.ceil((listKey?.totalResult || 0) / pageSize)}
                                        onClick={() => {
                                            const newPage = pageNumber + 1;
                                            setPageNumber(newPage);
                                            fetchListKey(newPage, statusKey, pageSize);
                                        }}
                                        size='small'
                                        type='default'
                                        className='px-2'
                                    >
                                        ›
                                    </Button>
                                </div>
                            </div>
                        </div>
                </div>


                    <div className='flex-1 overflow-hidden flex flex-col'>
                        <div className='flex-1 overflow-auto'>
                <Table
                                className="border-0"
                                pagination={false}
                                size="small"
                                dataSource={listKey?.page}
                                columns={[
                            {
                                title: "STT",
                                        render: (text, record, index) => (
                                            <span className="font-medium text-gray-600">
                                                {(pageNumber - 1) * pageSize + index + 1}
                                            </span>
                                        ),
                                key: 'id',
                                        width: '8%',
                                        align: 'center'
                            },
                            {
                                title: "Mã kích hoạt",
                                key: 'key',
                                        render: (text, record) => (
                                            <span className="font-mono font-bold text-sm text-emerald-600 tracking-wider uppercase whitespace-nowrap overflow-hidden text-ellipsis">
                                                {record.key}
                                            </span>
                                        ),
                                        width: '18%',
                                        align: 'center'
                                    },
                                    {
                                        title: "Loại mã",
                                        key: 'keyType',
                                        render: (text, record) => (
                                            <div className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-gradient-to-r from-green-100 to-emerald-100 text-green-800 border border-green-200 shadow-sm">
                                                <span className="w-1.5 h-1.5 bg-green-500 rounded-full mr-1.5"></span>
                                                {getLicensePackName(record.license_pack_id)}
                                            </div>
                                        ),
                                        width: '10%',
                                        align: 'center'
                            },
                            {
                                title: "Trạng thái",
                                        render: (text, record) => (
                                            <div className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium border shadow-sm ${
                                                record.status == 1
                                                    ? 'bg-gradient-to-r from-amber-50 to-orange-50 text-amber-800 border-amber-200'
                                                    : record.status == 3
                                                    ? 'bg-gradient-to-r from-emerald-50 to-green-50 text-emerald-800 border-emerald-200'
                                                    : 'bg-gradient-to-r from-red-50 to-rose-50 text-red-800 border-red-200'
                                            }`}>
                                                <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${
                                                    record.status == 1
                                                        ? 'bg-amber-500'
                                                        : record.status == 3
                                                        ? 'bg-emerald-500'
                                                        : 'bg-red-500'
                                                }`}></span>
                                                {record.status == 1 ? 'Chưa kích hoạt' : record.status == 3 ? "Đã kích hoạt" : "Đã thu hồi"}
                                            </div>
                                        ),
                                key: 'status',
                                        width: '12%',
                                        align: 'center'
                                    },
                                    {
                                        title: "Thời điểm kích hoạt",
                                        key: 'activationDate',
                                        render: (text, record) => {
                                            if (record.status !== 3 || !record.active_time) {
                                                return (
                                                    <div className="flex items-center justify-center text-xs text-slate-400 font-medium">
                                                        --
                                                    </div>
                                                );
                                            }
                                            
                                            // active_time là timestamp (seconds), convert to milliseconds
                                            const activationDate = new Date(record.active_time * 1000);
                                            const formattedDate = activationDate.toLocaleDateString('vi-VN');
                                            const formattedTime = activationDate.toLocaleTimeString('vi-VN', { 
                                                hour: '2-digit', 
                                                minute: '2-digit' 
                                            });
                                            
                                            return (
                                                <div className="flex items-center justify-center text-xs">
                                                    <span className="w-1.5 h-1.5 bg-green-500 rounded-full mr-1.5"></span>
                                                    <div className="flex items-center text-slate-700">
                                                        <span className="font-medium mr-1">{formattedDate}</span>
                                                        <span className="text-slate-500">{formattedTime}</span>
                                                    </div>
                                                </div>
                                            );
                                        },
                                        width: '18%',
                                        align: 'center'
                                    },
                                    {
                                        title: "Thông tin người kích hoạt",
                                        key: 'userInfo',
                                        render: (text, record) => {
                                            // Nếu chưa kích hoạt, hiển thị nội dung đơn giản
                                            if (record.status == 1) {
                                                return (
                                                    <div className="flex items-center text-xs text-slate-400 font-medium">
                                                        --
                                                    </div>
                                                );
                                            }

                                            // Nếu đã kích hoạt, hiển thị thông tin dựa trên provider
                                            const userInfo = record.user_info;
                                            if (!userInfo) {
                                                return (
                                                    <div className="flex items-center text-xs text-slate-400 font-medium">
                                                        --
                                                    </div>
                                                );
                                            }

                                            let displayLabel = "";
                                            let displayValue = "";
                                            
                                            switch (userInfo.sign_in_provider) {
                                                case "gofa":
                                                    displayLabel = "SĐT:";
                                                    displayValue = userInfo.phone_number || "--";
                                                    break;
                                                case "google":
                                                    displayLabel = "Email:";
                                                    displayValue = userInfo.email || "--";
                                                    break;
                                                case "apple":
                                                    displayLabel = "Apple ID:";
                                                    displayValue = userInfo.external_user_id || "--";
                                                    break;
                                                default:
                                                    displayLabel = "Info:";
                                                    displayValue = "--";
                                            }

                                            const fullText = `${displayLabel} ${displayValue}`;

                                            return (
                                                <div className="flex items-center text-xs text-slate-700">
                                                    <span className="w-1.5 h-1.5 bg-blue-500 rounded-full mr-1.5 flex-shrink-0"></span>
                                                    <Tooltip title="Xem thêm" placement="top">
                                                        <div 
                                                            className="flex items-center cursor-pointer rounded px-1 py-0.5 flex-1 min-w-0"
                                                            onClick={() => showInfoModal('Thông tin người kích hoạt', fullText)}
                                                        >
                                                            <span className="font-medium flex-shrink-0">{displayLabel}</span>
                                                            <span className="ml-1 text-slate-500 truncate flex-1 min-w-0">{displayValue}</span>
                                                        </div>
                                                    </Tooltip>
                                                </div>
                                            );
                                        },
                                        width: '25%',
                                    },
                                ]}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Loading Indicator */}
            {loading && (
                <>
                    {/* Overlay mờ */}
                    <div className="fixed inset-0 z-40 bg-black bg-opacity-10 pointer-events-none" />

                    {/* Loading content */}
                    <div className="fixed inset-0 z-50 flex items-center justify-center pointer-events-none">
                        <div className="flex items-center gap-3 text-gray-700 bg-white bg-opacity-90 rounded-lg px-6 py-4 shadow-lg">
                            <Spin size="default" />
                            <span className="text-base font-medium">Đang xử lý...</span>
                        </div>
                    </div>
                </>
            )}

            {/* Info Modal */}
            <Modal
                title={modalContent.title}
                open={modalVisible}
                onCancel={() => setModalVisible(false)}
                footer={[
                    <Button key="close" onClick={() => setModalVisible(false)}>
                        Đóng
                    </Button>
                ]}
                width={500}
                centered
            >
                <div className="py-4">
                    <p className="text-base text-gray-800 break-words whitespace-pre-wrap">
                        {modalContent.content}
                    </p>
                </div>
            </Modal>
        </div>
    );
};

export default Home;
